<template>
  <v-container fluid class="auth-page pa-0" style="height: 100vh;">
    <v-row class="fill-height ma-0">
      <!-- Right Side - Branding/Image Section (RTL layout) -->
      <v-col cols="12" md="6" class="brand-section pa-0 d-none d-md-flex">
        <div class="brand-content">
          <!-- Enhanced Logo Container -->
          <div class="logo-container mb-12">
            <div class="logo-wrapper">
              <v-img :src="require('@/assets/logo.svg')" contain height="120" width="220" class="mb-3 logo-enhanced"></v-img>
              <div class="logo-glow"></div>
            </div>
            <div class="logo-divider"></div>
          </div>
          
          <h1 class="text-h3 font-weight-bold white--text mb-4">ברוכים הבאים למערכת המשווקים</h1>
          <p class="text-subtitle-1 white--text mb-10">הפלטפורמה המתקדמת לניהול והקמת מנויי סלולר כשר</p>
          
          <div class="brand-features">
            <div v-for="(feature, index) in features" :key="index" class="feature-item">
              <div class="feature-icon">
                <v-icon color="white">{{ feature.icon }}</v-icon>
              </div>
              <div class="feature-text">
                <h3 class="text-subtitle-1 font-weight-bold white--text">{{ feature.title }}</h3>
                <p class="text-body-2 white--text text-opacity-80">{{ feature.text }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Decorative elements -->
        <div class="brand-overlay"></div>
        <div class="kosher-phone-illustration"></div>
        <div class="decorative-circles"></div>
      </v-col>

      <!-- Left Side - Form Section (RTL layout) -->
      <v-col cols="12" md="6" class="form-section d-flex align-center justify-center">
        <FormLogin />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormLogin from '@/components/auth/FormLogin.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: {
    FormLogin
  },
  data: () => ({
    features: [
      { 
        icon: 'mdi-cellphone-check', 
        title: 'הקמת מנויים מהירה',
        text: 'תהליך פשוט ומהיר להקמת מנויי סלולר כשר חדשים' 
      },
      { 
        icon: 'mdi-account-supervisor', 
        title: 'ניהול לקוחות',
        text: 'מעקב אחר לקוחות קיימים וחדשים במערכת מתקדמת' 
      },
      { 
        icon: 'mdi-chart-timeline-variant', 
        title: 'דוחות ביצועים',
        text: 'צפייה בנתוני מכירות בזמן אמת' 
      },
      { 
        icon: 'mdi-shield-check', 
        title: 'אבטחה מתקדמת',
        text: 'הגנה על מידע רגיש ופרטיות הלקוחות' 
      }
    ]
  }),
  mounted() {
    let auth = Auth.checkAuth();
    if (auth) {
      this.$router.replace({ name: "home"})
    }
    
    // Create decorative elements
    this.createDecorativeElements();
  },
  methods: {
    createDecorativeElements() {
      // Create decorative circles
      const circles = document.querySelector('.decorative-circles');
      if (circles) {
        for (let i = 0; i < 8; i++) {
          const circle = document.createElement('div');
          circle.className = 'decorative-circle';
          
          // Randomize position and size
          const size = 30 + Math.random() * 100;
          const top = Math.random() * 100;
          const right = Math.random() * 100;
          const opacity = 0.03 + Math.random() * 0.08;
          
          // Apply styles
          circle.style.position = 'absolute';
          circle.style.top = `${top}%`;
          circle.style.right = `${right}%`;
          circle.style.width = `${size}px`;
          circle.style.height = `${size}px`;
          circle.style.opacity = opacity;
          circle.style.borderRadius = '50%';
          circle.style.background = 'white';
          circle.style.zIndex = '1';
          
          // Add to container
          circles.appendChild(circle);
        }
      }
    }
  }
}
</script>

<style scoped>
.auth-page {
  overflow: hidden;
}

.brand-section {
  position: relative;
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 80px !important; /* Increased right padding */
  overflow: hidden;
}

.brand-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.1) 0%, rgba(13, 44, 109, 0) 70%);
  z-index: 1;
}

.brand-content {
  position: relative;
  z-index: 2;
  max-width: 500px;
}

/* Enhanced Logo Styling */
.logo-container {
  position: relative;
  display: inline-block;
}

.logo-wrapper {
  position: relative;
  display: inline-block;
}

.logo-enhanced {
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  animation: logo-pulse 3s ease-in-out infinite;
}

.logo-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  z-index: 1;
  animation: glow-pulse 3s ease-in-out infinite;
}

@keyframes logo-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes glow-pulse {
  0% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(0.8);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(0.8);
  }
}

.logo-divider {
  height: 4px;
  width: 100px;
  background: white;
  margin-top: 8px;
  border-radius: 2px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  padding-right: 12px; /* Added padding to move text away from right edge */
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  margin-left: 16px;
}

.feature-text {
  flex: 1;
}

.kosher-phone-illustration {
  position: absolute;
  bottom: 5%;
  left: 5%;
  width: 200px;
  height: 300px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.15)' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='5' y='2' width='14' height='20' rx='2' ry='2'/%3E%3Cline x1='12' y1='18' x2='12' y2='18'/%3E%3Cpath d='M8 2 L16 2 L16 4 L8 4 Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 1;
  transform: scale(3) rotate(-15deg);
  opacity: 0.2;
}

.decorative-circles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.decorative-circle {
  animation: float 20s ease-in-out infinite;
  animation-delay: calc(var(--i, 0) * -5s);
}

.form-section {
  background-color: #f8fafc;
  padding: 24px;
}

/* Animation for decorative elements */
@keyframes float {
  0% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-20px) scale(1.05);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

/* RTL Support */
.v-application {
  direction: rtl;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .form-section {
    padding: 16px;
  }
}
</style>